import type { ControllerProfile } from './types'

/**
 * Xbox controller profile.
 * Standard Xbox controller button and axis mappings.
 */
export const xboxProfile: ControllerProfile = {
  id: 'xbox',
  name: 'Xbox Controller',
  buttons: {
    select: 0,   // A button
    exit: 1,     // B button
    configure: 2, // X button
    menu: 9,     // Menu button
    rightBumper: 5,  // Right bumper (RB) - same behavior as select
  },
  axes: {
    leftStick: { x: 0, y: 1 },
    rightStick: { x: 2, y: 3 },
  },
  dpad: {
    up: 12,
    down: 13,
    left: 14,
    right: 15,
  },
  deadzone: 0.3,
}
